import Vue from 'vue'
import './styles/foundation.scss'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.mixin({
  data: () => ({
    // validations
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length > 3) || 'Use at least 4 characters',
    ],
    mobileRules: [
      v => !!v || 'Phone number is required',
      v => (v && !isNaN(v)) || 'Digits only',
      v => (v && String(v).length === 10) || 'Enter a valid 10-digit number',
    ],
    emailRules: [
      v => !!v || 'Email is required',
      v => (v && /^\S+@\S+\.\S+$/.test(v)) || 'Enter a valid email',
    ],
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 6) || 'At least 6 characters',
    ],
    messageRules: [
      v => !!v || 'Message is required',
      v => (v && v.length >= 10) || 'Please write at least 10 characters',
    ],
    socials: [
      { icon: 'mdi-facebook', to: 'https://www.facebook.com/people/Toeato/100086690146612/?mibextid=ZbWKwL', color: '#3b5998' },
      { icon: 'mdi-twitter', to: 'https://www.twitter.com/To_Eato', color: '#00acee' },
      { icon: 'mdi-youtube', to: 'https://www.youtube.com/@toeato', color: '#FF0000' },
      { icon: 'mdi-instagram', to: 'https://www.instagram.com/to_eato', color: '#8a3ab9' }
    ],
  }),
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
